import { ArrowRight, Linkedin } from './icons'
import { Reveal } from '../hooks/useReveal'

/** Tick inside the credential disc — one shape, tinted per issuer. */
const Verified = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true" focusable="false">
    <path
      d="m5 12.5 4.5 4.5L19 7.5"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

/**
 * The day job, condensed to a single tile so the projects above stay the
 * headline. Certifications sit under it as a compact badge row.
 */
export const Career = ({ career, certifications = [], links }) => (
  <section className="section" id="career">
    <div className="container">
      <Reveal className="section-head">
        <div>
          <p className="eyebrow">Career</p>
          <h2 className="section-title">The day job.</h2>
        </div>
        <p className="section-count">{career.domains.length} industries</p>
      </Reveal>

      <Reveal className="career">
        <div className="career__lead">
          <p className="career__years">{career.years}</p>
          <p className="career__years-label">{career.yearsLabel}</p>
        </div>

        <div className="career__main">
          <p className="career__now-label">Currently</p>
          <p className="career__role">{career.current.role}</p>
          <p className="career__company">
            {career.current.company}
            <span className="career__client"> · {career.current.client}</span>
            <span className="career__since"> · {career.current.since}</span>
          </p>

          <p className="career__arc">{career.arc}</p>

          <dl className="career__facts">
            <div>
              <dt>Previously</dt>
              <dd>{career.companies.join(' · ')}</dd>
            </div>
            <div>
              <dt>Industries</dt>
              <dd>{career.domains.join(' · ')}</dd>
            </div>
          </dl>

          <a
            className="career__link"
            href={links.linkedin}
            target="_blank"
            rel="noreferrer noopener"
          >
            <Linkedin />
            Full history on LinkedIn
            <ArrowRight className="career__link-arrow" />
            <span className="visually-hidden"> (opens in a new tab)</span>
          </a>
        </div>
      </Reveal>

      <Reveal delay={90} className="creds">
        <p className="creds__label">Certified</p>
        <ul className="creds__list">
          {certifications.map((cert) => (
            <li
              className="cred"
              key={cert.id}
              style={{ '--badge-accent': `var(--cert-${cert.id})` }}
            >
              <span className="cred__disc">
                <Verified />
              </span>
              <span className="cred__text">
                <b>{cert.name}</b>
                <span className="cred__meta">
                  {cert.issuer}
                  {cert.year && ` · ${cert.year}`}
                </span>
              </span>
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
)
